export enum PENDING_JOBS_HEADERS {
  NAME = 'name',
  UPDATED = 'updated',
}
